// Client-side CSV download. Ported from prototype `commonUtils.downloadCSV` /
// `csvFilename` (components.js §559). UTF-8 BOM prefix keeps Excel happy with
// Korean characters; RFC-4180-style escaping handles embedded quotes / commas /
// newlines.

type CsvCell = string | number | null | undefined;

function escapeCell(cell: CsvCell): string {
  const s = String(cell ?? '');
  if (/[",\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

export function downloadCSV(
  filename: string,
  headers: readonly string[],
  rows: readonly (readonly CsvCell[])[],
): void {
  const lines: string[] = [];
  if (headers.length) lines.push(headers.map(escapeCell).join(','));
  for (const row of rows) lines.push(row.map(escapeCell).join(','));

  const csv = '﻿' + lines.join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

const pad = (n: number) => String(n).padStart(2, '0');

// Pattern: `${prefix}_YYYYMMDD_HHmmss.csv` — used across the admin for any
// list export. PRD 03 §3.4 specifies `medical_staff_…` for this feature.
export function csvFilename(prefix: string): string {
  const d = new Date();
  return `${prefix}_${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}_${pad(d.getHours())}${pad(d.getMinutes())}${pad(d.getSeconds())}.csv`;
}
